import { axiosAjaxCall } from "./common.service";

export const leadsService = {
    getLeads,
}


function  getLeads(data) {    
    return axiosAjaxCall("get-leads", data);
}